import CustomForm from "../../../Forms/CustomForm";
import { useAgent } from "../../../../contexts/AgentsContext";

const DefineAgent = () => {
  const {
    validateRequiredField,
    updateOngoingAgentDataL1,
    lookUpValues,
    isLoadingDropdownFields,
  } = useAgent();

  const fields = [
    {
      name: "agent_name",
      label: "Agent Name",
      type: "text",
      required: true,
      placeholder: "Type Name",
      labelCls: "mas-form-label-regular",
      fieldCls: "custom-text-field-container",
    },
    {
      name: "LLM_model",
      label: "LLM Name",
      type: "dropdown",
      required: false,
      placeholder: "Select/Type to Search",
      labelCls: "mas-form-label-regular",
      fieldCls: "mas-cust-dd-primary mas-cust-dd-2",
      options: lookUpValues?.llms?.map((llm) => ({ label: llm, value: llm })) || [],
      loader: isLoadingDropdownFields?.llms,
      disabled: isLoadingDropdownFields?.llms,
    },
    {
      name: "agent_description",
      label: "Agent Description",
      type: "text",
      required: true,
      placeholder: "Type Description",
      labelCls: "mas-form-label-regular",
      fieldCls: "custom-text-field-container",
    },
    {
      name: "point_of_contact",
      label: "Point of Contact",
      type: "text",
      required: true,
      placeholder: "Type Name (e.g., Last Name, First Name)",
      labelCls: "mas-form-label-regular",
      fieldCls: "custom-text-field-container",
    },
    {
      name: "sample_prompt",
      label: "Sample Prompt",
      type: "text",
      required: true,
      placeholder: "Type Prompt",
      labelCls: "mas-form-label-regular",
      fieldCls: "mas-cust-dd-primary mas-cust-dd-2",
    },
  ];

  const handleFieldChange = (name, value) => {
    if (
      [
        "agent_name",
        "agent_description",
        "point_of_contact",
        "sample_prompt",
      ].includes(name)
    ) {
      validateRequiredField(name, value);
    }

    updateOngoingAgentDataL1(name, value);
  };

  return (
    <>
      <CustomForm
        clsNames={"mas-cust-form-container"}
        cols={[6, 6]}
        fields={fields}
        onFieldChange={handleFieldChange}
      />
    </>
  );
};

export default DefineAgent;
